import React, {FunctionComponent} from "react";
import {Box, makeStyles, useMediaQuery} from "@material-ui/core";
import Text from "../../../../commonComponents/Text";
import CheckBox from "../../../../commonComponents/CheckBox";
import {longInputWith} from "./StepContactData";
import {NotificationType} from "../../../../API";
import {useDispatch} from "react-redux";
import {toggleNotificationType} from "../../../state/contactSlice";
import InfoBox from "../../../../commonComponents/InfoBox";
import theme from "../../../../theme";

const useStyles = makeStyles(theme => ({
    checkBoxContainer: {
        width: longInputWith,
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        marginLeft: 20,
        [theme.breakpoints.down("xs")]: {
            marginLeft: 0,
            marginTop: 10,
            marginBottom: 20
        }
    }
}));

type NotificationSettingsType = {
    notificationType: NotificationType [];
    className?: string;
};

const NotificationSettings: FunctionComponent<NotificationSettingsType> = ({notificationType, className}) => {

    const dispatch = useDispatch();
    const isXs = useMediaQuery(theme.breakpoints.down("xs"));
    const isNotificationTypeChecked = (type: NotificationType): boolean => notificationType.includes(type);
    const classes = useStyles();
    return (
        <Box className={className}>
            <Box
                display={"flex"}
                position={"relative"}
                alignItems={"center"}
                flexDirection={isXs ? "row" : "row-reverse"}
            >
                <Text value={"Benachrichtigung"} size={12}/>
                <InfoBox
                    text={"Wir erheben, verarbeiten und nutzen die von Ihnen mitgeteilten personenbezogenen Daten für " +
                    "die Angebotserstellung, Durchführung und Abwicklung der vertraglichen Beziehung und Kaufabwicklung mit Ihnen."}
                    buttonContainerStyle={isXs ? {marginLeft: 7} : {marginRight: 7}}
                    infoSize={isXs ? 16 : 18}
                    infoBoxContainerStyle={{top: "calc(100% + 0.3em)"}}
                />
            </Box>
            <Box className={classes.checkBoxContainer}>
                <CheckBox
                    text={"E-Mail"}
                    checked={isNotificationTypeChecked(NotificationType.EMAIL)}
                    onClick={() => dispatch(toggleNotificationType(NotificationType.EMAIL))}
                />
                <CheckBox
                    text={"SMS"}
                    checked={isNotificationTypeChecked(NotificationType.SMS)}
                    onClick={() => dispatch(toggleNotificationType(NotificationType.SMS))}
                />
                <CheckBox
                    text={"WhatsApp"}
                    checked={isNotificationTypeChecked(NotificationType.WHATSAPP)}
                    onClick={() => dispatch(toggleNotificationType(NotificationType.WHATSAPP))}
                />
            </Box>
        </Box>
    );
};

export default NotificationSettings;
